module.exports = __webpack_public_path__ + "img/motive-1.d40b859b.jpg";